import { request } from "../utils/request.js"

export const customerType_addNew = (pojo, args) => request({
    url: 'customerType/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customerType_update = (pojo, args) => request({
    url: 'customerType/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customerType_findPageForManage = (pojo, args) => request({
    url: 'customerType/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customerType_findPageForSelect = (pojo, args) => request({
    url: 'customerType/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customerType_changeFrozenStatus = (id, args) => request({
    url: 'customerType/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customerType_findById = (id, args) => request({
    url: 'customerType/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customerType_findAllList = (args) => request({
    url: 'customerType/findAllList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const customerType_delete = (id, args) => request({
    url: 'customerType/delete',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customerType.js